import React, { useMemo } from 'react';
import { SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { string } from 'prop-types';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';
import VideogameAssetOutlinedIcon from '@mui/icons-material/VideogameAssetOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { ReactComponent as NBIcon } from '#static/media/NBIcon.svg';
import { ReactComponent as SHIcon } from '#static/media/SHIcon.svg';

/**
 * Renders device icon based on device type.
 * @returns {React.FC}
 */

const DeviceIcon = ({
  icon = '',
  className,
  style,
  isActive = false,
  isError = false
}) => {
  const theme = useTheme();
  const extendedStyle = useMemo(() => ({
    color: isError ? '#ba9100' : isActive ? '#5eb676' : theme.palette.grey[600],
    ...style
  }), [isError, isActive, theme.palette.grey, style]);

  let Icon;

  switch (icon) {
    case 'freezer':
      Icon = AcUnitIcon;
      break;
    case 'nelumbox':
      Icon = NBIcon;
      break;
    case 'smarthub':
      Icon = SHIcon;
      break;
    case 'beacon':
      Icon = SettingsRemoteOutlinedIcon;
      break;
    case 'home':
      Icon = RadioButtonUncheckedIcon;
      break;
    default:
      Icon = VideogameAssetOutlinedIcon;
  }

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg" // new Image().src =
      component={Icon}
      style={extendedStyle}
      className={className}
    />
  );
};

DeviceIcon.propTypes = {
  icon: string
};

export default DeviceIcon;
